export const environment = {
  API_URL: 'https://dev1-api-truong.onluyen.io.vn',
  API_LOGIN: 'https://oauth-dev.onluyen.io/api/account/login',
  SCHOOLX: 'https://dev-onluyen.schoolx.vn',
};
